module.exports = __webpack_public_path__ + "static/media/рай-en.170bb890.svg";